module.exports = __webpack_public_path__ + "img/BTC-icon.60883d2f.png";